var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_270_2014)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 90.547,
    height: 90.547,
    rx: 45.2735,
    fill: "#C7710D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 65.9,
    height: 64.146,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_270_2014",
    x: 0.0249691,
    y: 0.512485,
    width: 148.497,
    height: 148.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.4875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.4875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_2014"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_2014",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_270_2014",
    transform: "matrix(0.00666667 0 0 0.00684896 0 -0.0136719)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_270_2014",
    width: 150,
    height: 150,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.5162aa20e0e543b05caef1f742ad2837.svg";
export { ForwardRef as ReactComponent };